export type Language = 'pt' | 'en' | 'es'

export const translations = {
  pt: {
    nav: {
      home: 'Sola Notes',
      generate: 'Gerar',
      annotations: 'Anotações',
      profile: 'Perfil',
    },
    home: {
      greeting_morning: 'Bom dia',
      greeting_afternoon: 'Boa tarde',
      greeting_evening: 'Boa noite',
      study_prompt: 'Vamos estudar hoje?',
      continue_studies: 'Continue seus estudos',
      library_empty: 'Sua biblioteca está vazia.',
      library_empty_sub: 'Gere sua primeira Sola Note.',
      day_of: 'Dia {{current}} de {{total}}',
      completed: '{{n}} concluídos',
      my_library: 'Minha Biblioteca',
      collections: 'Coleções',
      new_badge: 'Nova',
      filter_church: 'Igreja',
      filter_book: 'Livro',
      filter_preacher: 'Pregador',
      filter_artist: 'Artista',
      filter_all_churches: 'Todas as igrejas',
      filter_all_books: 'Todos os livros',
      filter_all_preachers: 'Todos os pregadores',
      filter_all_artists: 'Todos os artistas',
      filter_clear: 'Limpar',
      filter_clear_aria: 'Limpar filtros',
      no_notes_available: 'Nenhuma Sola Notes disponível ainda.',
      delete_note_title: 'Excluir esta Sola Note?',
      delete_note_description: '"{{title}}" será removida permanentemente, junto com seus destaques e progresso devocional. Esta ação não pode ser desfeita.',
      delete_in_progress: 'Excluindo...',
      delete_action: 'Excluir',
      add_to_collection: 'Adicionar à coleção',
      share: 'Compartilhar',
      more_options: 'Mais opções',
      music_label: 'Música',
      no_church_label: 'Sem igreja',
      church_default: 'Pregação',
    },
    generate: {
      title: 'Gerar Sola Notes',
      tab_sermon: 'Pregação',
      tab_study: 'Estudo',
      tab_music: 'Música',
      input_placeholder: 'Cole o link do YouTube ou Spotify',
      button_generate: 'Gerar Sola Notes',
      button_generating: 'Gerando...',
      transcribing: 'Transcrevendo áudio...',
      structuring: 'Estruturando conteúdo...',
      generating_devotional: 'Gerando devocional...',
      success: 'Sola Note gerada com sucesso!',
      error_invalid_url: 'Link inválido. Use YouTube ou Spotify.',
      error_generic: 'Erro ao gerar. Tente novamente.',
      saving: 'Salvando no banco de dados...',
      generating: 'Gerando Sola Notes com IA...',
      done: 'Sola Notes criada com sucesso!',
      view_note: 'Ver Sola Notes',
      music_identified: 'Música identificada',
      metadata_on_generate: 'Metadados serão extraídos na geração',
      placeholder_sermon: 'Cole o link da pregação aqui',
      placeholder_study: 'Cole o link do estudo bíblico aqui',
      placeholder_music: 'Cole o link da música aqui',
      youtube_spotify_link: 'Link do YouTube ou Spotify',
      music_link: 'Link da música',
      coming_soon_tooltip: 'Este recurso estará disponível em breve',
      login_required: 'Faça login para continuar.',
      invalid_url: 'Cole um link válido do YouTube ou Spotify.',
      quota_reached: 'Cota mensal atingida ({{used}}/{{total}})',
      quota_remaining: '{{remaining}} de {{total}} Smart Notes restantes este mês',
    },
    note: {
      central_theme: 'Tema Central',
      proposition: 'Proposição',
      sermon_structure: 'Estrutura do Sermão',
      key_verses: 'Versículos-Chave',
      practical_applications: 'Aplicações Práticas',
      devotional: 'Devocional',
      day: 'Dia',
      mark_complete: 'Marcar como concluído',
      completed_day: 'Dia concluído',
      locked: 'Disponível no plano Sola+',
      preacher: 'Pregador',
      date: 'Data',
    },
    annotations: {
      title: 'Minhas Anotações',
      empty: 'Nenhuma anotação ainda.',
      empty_sub: 'Marque trechos nas suas Sola Notes.',
      highlight: 'Destacar',
      annotate: 'Anotar',
      copy: 'Copiar',
      empty_main: 'Seus destaques aparecerão aqui',
      empty_hint: 'Selecione textos nas pregações para começar',
      filter_all: 'Todos',
      filter_favorites: 'Favoritos',
      filter_highlights: 'Destaques',
      filter_bold: 'Negrito',
      filter_underline: 'Sublinhado',
      filter_comments: 'Notas',
      type_highlight: 'Destaque',
      type_bold: 'Negrito',
      type_underline: 'Sublinhado',
      type_comment: 'Comentário',
      tag_devotional: 'Devocional',
      tag_sermon: 'Pregação',
      has_note: 'Tem nota',
      view_in_sermon: 'Ver na pregação',
      remove: 'Remover',
      favorite: 'Favoritar',
      unfavorite: 'Remover favorito',
      default_sermon_title: 'Pregação',
    },
    profile: {
      title: 'Perfil',
      my_plan: 'Meu Plano',
      notes_this_month: 'Notas este mês',
      language: 'Idioma',
      language_select: 'Selecionar idioma',
      notifications: 'Notificações',
      tutorial: 'Tutorial',
      logout: 'Sair',
      plan_free: 'Gratuito',
      plan_sola: 'Sola',
      plan_sola_plus: 'Sola+',
      plan_sola_pro: 'Sola Pro',
      notes_used: '{{used}} de {{total}} notas usadas',
      my_plan_title: 'Meu plano',
      upgrade_cta: 'Fazer upgrade →',
      manage_subscription: 'Gerenciar assinatura →',
      portal_no_sub_title: 'Sem assinatura ativa',
      portal_no_sub_desc: 'Você não possui uma assinatura recorrente para gerenciar.',
      portal_open_error: 'Não foi possível abrir o portal',
      notes_generated_month: 'Notas geradas este mês',
      unlimited_notes: 'Notas ilimitadas neste plano',
      notes_this_month_label: 'Notas este mês',
      change_photo: 'Alterar foto',
      year_one: 'ano',
      year_other: 'anos',
      send_test_notification: 'Enviar notificação de teste',
      test_notification_title: 'Notificação de teste ✓',
      test_notification_body: 'Tudo certo! Você receberá lembretes assim.',
      test_send_error: 'Erro ao testar',
      test_send_success_title: 'Teste enviado',
      test_send_success_desc: 'Verifique a central de notificações.',
      view_tutorial_title: 'Ver tutorial novamente',
      view_tutorial_desc: 'Reabra o tour guiado de 9 passos',
      terms_link: 'Termos de Uso',
      privacy_link: 'Privacidade',
      version_label: 'versão',
    },
    auth: {
      welcome: 'Bem-vindo ao Sola Notes',
      subtitle: 'Estude a Palavra com profundidade.',
      email: 'E-mail',
      password: 'Senha',
      name: 'Nome completo',
      login: 'Entrar',
      register: 'Criar conta',
      forgot_password: 'Esqueci minha senha',
      already_have_account: 'Já tem uma conta?',
      no_account: 'Não tem uma conta?',
      select_language: 'Selecione seu idioma',
      language_pt: 'Português',
      language_en: 'English',
      language_es: 'Español',
    },
    common: {
      save: 'Salvar',
      cancel: 'Cancelar',
      close: 'Fechar',
      back: 'Voltar',
      next: 'Próximo',
      finish: 'Concluir',
      loading: 'Carregando...',
      error: 'Erro',
      success: 'Sucesso',
      coming_soon: 'Em breve',
      free: 'Grátis',
      month: 'mês',
      year: 'ano',
      link_copied_title: 'Link copiado',
      link_copied_desc: 'Cole e compartilhe com quem quiser.',
      share_failed: 'Não foi possível compartilhar',
      delete_error: 'Erro ao excluir',
      note_deleted_title: 'Sola Note excluída',
    },
  },
  en: {
    nav: {
      home: 'Sola Notes',
      generate: 'Generate',
      annotations: 'Annotations',
      profile: 'Profile',
    },
    home: {
      greeting_morning: 'Good morning',
      greeting_afternoon: 'Good afternoon',
      greeting_evening: 'Good evening',
      study_prompt: "Let's study today?",
      continue_studies: 'Continue your studies',
      library_empty: 'Your library is empty.',
      library_empty_sub: 'Generate your first Sola Note.',
      day_of: 'Day {{current}} of {{total}}',
      completed: '{{n}} completed',
      my_library: 'My Library',
      collections: 'Collections',
      new_badge: 'New',
      filter_church: 'Church',
      filter_book: 'Book',
      filter_preacher: 'Preacher',
      filter_artist: 'Artist',
      filter_all_churches: 'All churches',
      filter_all_books: 'All books',
      filter_all_preachers: 'All preachers',
      filter_all_artists: 'All artists',
      filter_clear: 'Clear',
      filter_clear_aria: 'Clear filters',
      no_notes_available: 'No Sola Notes available yet.',
      delete_note_title: 'Delete this Sola Note?',
      delete_note_description: '"{{title}}" will be permanently removed, along with its highlights and devotional progress. This action cannot be undone.',
      delete_in_progress: 'Deleting...',
      delete_action: 'Delete',
      add_to_collection: 'Add to collection',
      share: 'Share',
      more_options: 'More options',
      music_label: 'Music',
      no_church_label: 'No church',
      church_default: 'Sermon',
    },
    generate: {
      title: 'Generate Sola Notes',
      tab_sermon: 'Sermon',
      tab_study: 'Study',
      tab_music: 'Music',
      input_placeholder: 'Paste your YouTube or Spotify link',
      button_generate: 'Generate Sola Notes',
      button_generating: 'Generating...',
      transcribing: 'Transcribing audio...',
      structuring: 'Structuring content...',
      generating_devotional: 'Generating devotional...',
      success: 'Sola Note generated successfully!',
      error_invalid_url: 'Invalid link. Use YouTube or Spotify.',
      error_generic: 'Error generating. Please try again.',
      saving: 'Saving to database...',
      generating: 'Generating Sola Notes with AI...',
      done: 'Sola Notes created successfully!',
      view_note: 'View Sola Notes',
      music_identified: 'Music identified',
      metadata_on_generate: 'Metadata will be extracted on generation',
      placeholder_sermon: 'Paste the sermon link here',
      placeholder_study: 'Paste the Bible study link here',
      placeholder_music: 'Paste the music link here',
      youtube_spotify_link: 'YouTube or Spotify link',
      music_link: 'Music link',
      coming_soon_tooltip: 'This feature will be available soon',
      login_required: 'Sign in to continue.',
      invalid_url: 'Paste a valid YouTube or Spotify link.',
      quota_reached: 'Monthly quota reached ({{used}}/{{total}})',
      quota_remaining: '{{remaining}} of {{total}} Smart Notes remaining this month',
    },
    note: {
      central_theme: 'Central Theme',
      proposition: 'Proposition',
      sermon_structure: 'Sermon Structure',
      key_verses: 'Key Verses',
      practical_applications: 'Practical Applications',
      devotional: 'Devotional',
      day: 'Day',
      mark_complete: 'Mark as complete',
      completed_day: 'Day completed',
      locked: 'Available on Sola+ plan',
      preacher: 'Preacher',
      date: 'Date',
    },
    annotations: {
      title: 'My Annotations',
      empty: 'No annotations yet.',
      empty_sub: 'Highlight passages in your Sola Notes.',
      highlight: 'Highlight',
      annotate: 'Annotate',
      copy: 'Copy',
      empty_main: 'Your highlights will appear here',
      empty_hint: 'Select text in the sermons to get started',
      filter_all: 'All',
      filter_favorites: 'Favorites',
      filter_highlights: 'Highlights',
      filter_bold: 'Bold',
      filter_underline: 'Underline',
      filter_comments: 'Notes',
      type_highlight: 'Highlight',
      type_bold: 'Bold',
      type_underline: 'Underline',
      type_comment: 'Comment',
      tag_devotional: 'Devotional',
      tag_sermon: 'Sermon',
      has_note: 'Has note',
      view_in_sermon: 'View in sermon',
      remove: 'Remove',
      favorite: 'Favorite',
      unfavorite: 'Remove favorite',
      default_sermon_title: 'Sermon',
    },
    profile: {
      title: 'Profile',
      my_plan: 'My Plan',
      notes_this_month: 'Notes this month',
      language: 'Language',
      language_select: 'Select language',
      notifications: 'Notifications',
      tutorial: 'Tutorial',
      logout: 'Sign out',
      plan_free: 'Free',
      plan_sola: 'Sola',
      plan_sola_plus: 'Sola+',
      plan_sola_pro: 'Sola Pro',
      notes_used: '{{used}} of {{total}} notes used',
      my_plan_title: 'My plan',
      upgrade_cta: 'Upgrade →',
      manage_subscription: 'Manage subscription →',
      portal_no_sub_title: 'No active subscription',
      portal_no_sub_desc: 'You do not have a recurring subscription to manage.',
      portal_open_error: 'Could not open the portal',
      notes_generated_month: 'Notes generated this month',
      unlimited_notes: 'Unlimited notes on this plan',
      notes_this_month_label: 'Notes this month',
      change_photo: 'Change photo',
      year_one: 'year',
      year_other: 'years',
      send_test_notification: 'Send test notification',
      test_notification_title: 'Test notification ✓',
      test_notification_body: 'All set! You will receive reminders like this.',
      test_send_error: 'Test failed',
      test_send_success_title: 'Test sent',
      test_send_success_desc: 'Check the notifications center.',
      view_tutorial_title: 'View tutorial again',
      view_tutorial_desc: 'Reopen the 9-step guided tour',
      terms_link: 'Terms of Use',
      privacy_link: 'Privacy',
      version_label: 'version',
    },
    auth: {
      welcome: 'Welcome to Sola Notes',
      subtitle: 'Study the Word with depth.',
      email: 'Email',
      password: 'Password',
      name: 'Full name',
      login: 'Sign in',
      register: 'Create account',
      forgot_password: 'Forgot my password',
      already_have_account: 'Already have an account?',
      no_account: "Don't have an account?",
      select_language: 'Select your language',
      language_pt: 'Português',
      language_en: 'English',
      language_es: 'Español',
    },
    common: {
      save: 'Save',
      cancel: 'Cancel',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      finish: 'Finish',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      coming_soon: 'Coming soon',
      free: 'Free',
      month: 'month',
      year: 'year',
      link_copied_title: 'Link copied',
      link_copied_desc: 'Paste it and share with whoever you want.',
      share_failed: 'Could not share',
      delete_error: 'Error deleting',
      note_deleted_title: 'Sola Note deleted',
    },
  },
  es: {
    nav: {
      home: 'Sola Notes',
      generate: 'Generar',
      annotations: 'Anotaciones',
      profile: 'Perfil',
    },
    home: {
      greeting_morning: 'Buenos días',
      greeting_afternoon: 'Buenas tardes',
      greeting_evening: 'Buenas noches',
      study_prompt: '¿Estudiamos hoy?',
      continue_studies: 'Continúa tus estudios',
      library_empty: 'Tu biblioteca está vacía.',
      library_empty_sub: 'Genera tu primera Sola Note.',
      day_of: 'Día {{current}} de {{total}}',
      completed: '{{n}} completados',
      my_library: 'Mi Biblioteca',
      collections: 'Colecciones',
      new_badge: 'Nueva',
      filter_church: 'Iglesia',
      filter_book: 'Libro',
      filter_preacher: 'Predicador',
      filter_artist: 'Artista',
      filter_all_churches: 'Todas las iglesias',
      filter_all_books: 'Todos los libros',
      filter_all_preachers: 'Todos los predicadores',
      filter_all_artists: 'Todos los artistas',
      filter_clear: 'Limpiar',
      filter_clear_aria: 'Limpiar filtros',
      no_notes_available: 'Aún no hay Sola Notes disponibles.',
      delete_note_title: '¿Eliminar esta Sola Note?',
      delete_note_description: '"{{title}}" se eliminará permanentemente, junto con tus destacados y progreso devocional. Esta acción no se puede deshacer.',
      delete_in_progress: 'Eliminando...',
      delete_action: 'Eliminar',
      add_to_collection: 'Añadir a la colección',
      share: 'Compartir',
      more_options: 'Más opciones',
      music_label: 'Música',
      no_church_label: 'Sin iglesia',
      church_default: 'Sermón',
    },
    generate: {
      title: 'Generar Sola Notes',
      tab_sermon: 'Sermón',
      tab_study: 'Estudio',
      tab_music: 'Música',
      input_placeholder: 'Pega tu enlace de YouTube o Spotify',
      button_generate: 'Generar Sola Notes',
      button_generating: 'Generando...',
      transcribing: 'Transcribiendo audio...',
      structuring: 'Estructurando contenido...',
      generating_devotional: 'Generando devocional...',
      success: '¡Sola Note generada con éxito!',
      error_invalid_url: 'Enlace inválido. Usa YouTube o Spotify.',
      error_generic: 'Error al generar. Inténtalo de nuevo.',
      saving: 'Guardando en la base de datos...',
      generating: 'Generando Sola Notes con IA...',
      done: '¡Sola Notes creada con éxito!',
      view_note: 'Ver Sola Notes',
      music_identified: 'Música identificada',
      metadata_on_generate: 'Los metadatos se extraerán al generar',
      placeholder_sermon: 'Pega aquí el enlace del sermón',
      placeholder_study: 'Pega aquí el enlace del estudio bíblico',
      placeholder_music: 'Pega aquí el enlace de la música',
      youtube_spotify_link: 'Enlace de YouTube o Spotify',
      music_link: 'Enlace de música',
      coming_soon_tooltip: 'Esta función estará disponible pronto',
      login_required: 'Inicia sesión para continuar.',
      invalid_url: 'Pega un enlace válido de YouTube o Spotify.',
      quota_reached: 'Cuota mensual alcanzada ({{used}}/{{total}})',
      quota_remaining: '{{remaining}} de {{total}} Smart Notes restantes este mes',
    },
    note: {
      central_theme: 'Tema Central',
      proposition: 'Proposición',
      sermon_structure: 'Estructura del Sermón',
      key_verses: 'Versículos Clave',
      practical_applications: 'Aplicaciones Prácticas',
      devotional: 'Devocional',
      day: 'Día',
      mark_complete: 'Marcar como completado',
      completed_day: 'Día completado',
      locked: 'Disponible en el plan Sola+',
      preacher: 'Predicador',
      date: 'Fecha',
    },
    annotations: {
      title: 'Mis Anotaciones',
      empty: 'Sin anotaciones todavía.',
      empty_sub: 'Marca pasajes en tus Sola Notes.',
      highlight: 'Resaltar',
      annotate: 'Anotar',
      copy: 'Copiar',
      empty_main: 'Tus destacados aparecerán aquí',
      empty_hint: 'Selecciona texto en los sermones para empezar',
      filter_all: 'Todos',
      filter_favorites: 'Favoritos',
      filter_highlights: 'Destacados',
      filter_bold: 'Negrita',
      filter_underline: 'Subrayado',
      filter_comments: 'Notas',
      type_highlight: 'Destacado',
      type_bold: 'Negrita',
      type_underline: 'Subrayado',
      type_comment: 'Comentario',
      tag_devotional: 'Devocional',
      tag_sermon: 'Sermón',
      has_note: 'Tiene nota',
      view_in_sermon: 'Ver en el sermón',
      remove: 'Quitar',
      favorite: 'Favorito',
      unfavorite: 'Quitar favorito',
      default_sermon_title: 'Sermón',
    },
    profile: {
      title: 'Perfil',
      my_plan: 'Mi Plan',
      notes_this_month: 'Notas este mes',
      language: 'Idioma',
      language_select: 'Seleccionar idioma',
      notifications: 'Notificaciones',
      tutorial: 'Tutorial',
      logout: 'Cerrar sesión',
      plan_free: 'Gratis',
      plan_sola: 'Sola',
      plan_sola_plus: 'Sola+',
      plan_sola_pro: 'Sola Pro',
      notes_used: '{{used}} de {{total}} notas usadas',
      my_plan_title: 'Mi plan',
      upgrade_cta: 'Mejorar plan →',
      manage_subscription: 'Gestionar suscripción →',
      portal_no_sub_title: 'Sin suscripción activa',
      portal_no_sub_desc: 'No tienes una suscripción recurrente para gestionar.',
      portal_open_error: 'No se pudo abrir el portal',
      notes_generated_month: 'Notas generadas este mes',
      unlimited_notes: 'Notas ilimitadas en este plan',
      notes_this_month_label: 'Notas este mes',
      change_photo: 'Cambiar foto',
      year_one: 'año',
      year_other: 'años',
      send_test_notification: 'Enviar notificación de prueba',
      test_notification_title: 'Notificación de prueba ✓',
      test_notification_body: '¡Todo listo! Recibirás recordatorios así.',
      test_send_error: 'Error al probar',
      test_send_success_title: 'Prueba enviada',
      test_send_success_desc: 'Revisa el centro de notificaciones.',
      view_tutorial_title: 'Ver tutorial de nuevo',
      view_tutorial_desc: 'Reabre el tour guiado de 9 pasos',
      terms_link: 'Términos de Uso',
      privacy_link: 'Privacidad',
      version_label: 'versión',
    },
    auth: {
      welcome: 'Bienvenido a Sola Notes',
      subtitle: 'Estudia la Palabra con profundidad.',
      email: 'Correo electrónico',
      password: 'Contraseña',
      name: 'Nombre completo',
      login: 'Iniciar sesión',
      register: 'Crear cuenta',
      forgot_password: 'Olvidé mi contraseña',
      already_have_account: '¿Ya tienes una cuenta?',
      no_account: '¿No tienes una cuenta?',
      select_language: 'Selecciona tu idioma',
      language_pt: 'Português',
      language_en: 'English',
      language_es: 'Español',
    },
    common: {
      save: 'Guardar',
      cancel: 'Cancelar',
      close: 'Cerrar',
      back: 'Volver',
      next: 'Siguiente',
      finish: 'Finalizar',
      loading: 'Cargando...',
      error: 'Error',
      success: 'Éxito',
      coming_soon: 'Próximamente',
      free: 'Gratis',
      month: 'mes',
      year: 'año',
      link_copied_title: 'Enlace copiado',
      link_copied_desc: 'Pégalo y compártelo con quien quieras.',
      share_failed: 'No se pudo compartir',
      delete_error: 'Error al eliminar',
      note_deleted_title: 'Sola Note eliminada',
    },
  },
} as const

export type TranslationKey = typeof translations.pt

export function t(
  lang: Language,
  key: string,
  vars?: Record<string, string | number>
): string {
  const keys = key.split('.')
  let value: any = translations[lang] ?? translations['pt']
  for (const k of keys) {
    value = value?.[k]
  }
  if (typeof value !== 'string') {
    // Fallback para pt se chave não encontrada
    let fallback: any = translations['pt']
    for (const k of keys) fallback = fallback?.[k]
    return typeof fallback === 'string' ? fallback : key
  }
  if (!vars) return value
  return Object.entries(vars).reduce(
    (str, [k, v]) => str.replace(`{{${k}}}`, String(v)),
    value
  )
}